import { render, staticRenderFns } from "./contract-assets-chart.vue?vue&type=template&id=06e24186"
import script from "./contract-assets-chart.vue?vue&type=script&lang=js"
export * from "./contract-assets-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports